export const tamediaColors = {
  brandblue: {
    main: '#202346',
    bright1: '#474a66',
    bright2: '#6f7187',
    bright3: '#9698a8',
    bright4: '#c8c8d1',
    bright5: '#f0f0f2',
  },
  blue: {
    dark2: '#1b475e',
    dark1: '#296a8d',
    main: '#378ebd',
    bright1: '#69aacd',
    bright2: '#9bc6de',
    bright3: '#cde2ee',
  },
  yellow: {
    main: '#ffe462',
  },
  petrol: {
    dark2: '#16514f',
    dark1: '#217977',
    main: '#2ca29f',
    bright1: '#60b9b7',
    bright2: '#95d0cf',
    bright3: '#cae7e7',
  },
  green: {
    dark2: '#234930',
    dark1: '#356d48',
    main: '#479260',
    bright1: '#75ad87',
    bright2: '#a3c8af',
    bright3: '#d1e3d7',
  },
  purple: {
    dark2: '#512a4f',
    dark1: '#7a3f77',
    main: '#a757a3',
    bright1: '#ba7fb7',
    bright2: '#d1aacf',
    bright3: '#e8d4e7',
  },
  orange: {
    dark2: '#703600',
    dark1: '#964800',
    main: '#e16d00',
    bright1: '#e78d38',
    bright2: '#f1be8d',
    bright3: '#f8dec6',
  },
  red: {
    dark2: '#691a1f',
    dark1: '#9e272f',
    main: '#d3343f',
    bright1: '#de666f',
    bright2: '#e9999f',
    bright3: '#f4cccf',
  },
  beige: {
    dark2: '#575247',
    dark1: '#7b7768',
    main: '#a09c8a',
    bright1: '#dcd8c9',
    bright2: '#efece0',
    bright3: '#f8f7f4',
  },
  gray: {
    gray1: '#323232',
    gray2: '#555',
    gray3: '#7d7d7d',
    gray4: '#d4d4d4',
    gray5: '#e9e9e9',
    gray6: '#f4f4f4',
  },
  offBlack: '#121212',
  tenants: {
    light: {
      bz: '#800000',
      bol: '#800000',
      lt: '#800000',
      tt: '#800000',
      zrz: '#2c3890',
      tdg: '#2c3890',
      zul: '#2c3890',
      l: '#2c3890',
      baz: '#d9010e',
      '24h': '#d9010e',
      bnd: '#0085ab',
      ta: '#0085ab',
    },
    dark: {
      bz: '#9c3838',
      bol: '#9c3838',
      lt: '#9c3838',
      tt: '#9c3838',
      zrz: '#5a64a8',
      tdg: '#5a64a8',
      zul: '#5a64a8',
      l: '#5a64a8',
    },
  },
}
